import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import TableListIcon from '../icons/TableListIcon';
import StrockListIcon from '../icons/StrockListIcon';
import CardListIcon from '../icons/CardListIcon';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from '@material-ui/core/Tooltip';
// import ListItemText from '@material-ui/core/ListItemText';
// import Divider from '@material-ui/core/Divider';
// import InboxIcon from '@material-ui/icons/Inbox';
// import DraftsIcon from '@material-ui/icons/Drafts';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: 'none',
	},

	listItem: {
		width: 48,
		height: 48,
		padding: 12,
		borderRadius: '16px',
		'& .MuiListItem-root.Mui-selected': {
			// backgroundColor: 'red'
		}
	},

	tblview: {
		[theme.breakpoints.down(1366)]: {
			display: 'none'
		}
	},
}));

const CustomIconButton = withStyles((theme) => ({
	root: {
		color: 'white',
		backgroundColor: '#FFFFFF',
		borderRadius: '16px',

		// '&:hover': {
		// 	backgroundColor: 'black',
		// },
	},
}))(IconButton);

const SelectedCustomIconButton = withStyles((theme) => ({
	root: {
		color: 'white',
		backgroundColor: '#BCBBD0',
		borderRadius: '16px',

		// '&:focus': {
		// 	backgroundColor: 'black',
		// },

		// '&:hover': {
		// 	backgroundColor: '#BCBBD0',
		// },
	},
}))(IconButton);

export default function ChangeViewArray(props) {
	const classes = useStyles();
	const lang = localStorage.getItem('language') || 'Ru'

	function handle(index, count) {
		// props.handleCount(count)
		props.handleView(index)
	}


	return (
		<Grid container>
			{props.selected === 1
				?
				<CustomTooltip title={lang === 'Ru' ? 'Плиточный вид' : "Tile view"} disableFocusListener={true}>
					<SelectedCustomIconButton onClick={() => handle('tile')} style={{ marginRight: 8 }} aria-label="delete">
						<CardListIcon fill={props.selected === 1 ? '#FFFFFF' : '#BCBBD0'} />
					</SelectedCustomIconButton>
				</CustomTooltip>
				:
				<CustomTooltip title={lang === 'Ru' ? 'Плиточный вид' : "Tile view"} disableFocusListener={true}>
					<CustomIconButton onClick={() => handle('tile')} style={{ marginRight: 8 }} aria-label="delete">
						<CardListIcon fill={props.selected === 1 ? '#FFFFFF' : '#BCBBD0'} />
					</CustomIconButton>
				</CustomTooltip>
			}

			{props.selected === 0 || (props.disabled2 && props.selected === 2)
				?
				<CustomTooltip title={lang === 'Ru' ? 'Списочный вид' : "List view"} disableFocusListener={true}>
					<SelectedCustomIconButton onClick={handle('table')} style={{ marginRight: 8 }} aria-label="delete">
						<StrockListIcon fill={props.selected === 0 ? '#FFFFFF' : '#BCBBD0'} />
					</SelectedCustomIconButton>
				</CustomTooltip>
				:
				<CustomTooltip title={lang === 'Ru' ? 'Списочный вид' : "List view"} disableFocusListener={true}>
					<CustomIconButton onClick={() => handle('table')} style={{ marginRight: 8 }} aria-label="delete">
						<StrockListIcon fill={props.selected === 0 ? '#FFFFFF' : '#BCBBD0'} />
					</CustomIconButton>
				</CustomTooltip>
			}

			{props.page && props.page === 'applist'
				?
				props.selected === 2
					?
					<CustomTooltip title={lang === 'Ru' ? 'Табличный вид' : "Table view"} disableFocusListener={true}>
						<SelectedCustomIconButton disabled={props.disabled2} onClick={() => handle('tbl')} aria-label="delete" className={classes.tblview}>
							<TableListIcon fill={props.selected === 2 ? '#FFFFFF' : '#BCBBD0'} />
						</SelectedCustomIconButton>
					</CustomTooltip>
					:
					<CustomTooltip title={lang === 'Ru' ? 'Табличный вид' : "Table view"} disableFocusListener={true}>
						<CustomIconButton disabled={props.disabled2} onClick={() => handle('tbl')} aria-label="delete" className={classes.tblview}>
							<TableListIcon fill={props.selected === 2 ? '#FFFFFF' : '#BCBBD0'} />
						</CustomIconButton>
					</CustomTooltip>
				:
				''
			}


			{/* <List component="nav" aria-label="main mailbox folders" style={{ width: 'fit-content', padding: 0 }}>
				<Grid
					container
					direction="row"
					justify="flex-start"
					alignItems="center"
				>
					<Link to={`${url.replace('viewtable', 'viewtile')}${history.location.search}`}>
						<Grid item style={{ background: '#FFF', borderRadius: '16px', marginRight: 8, }}>
							<StyledListItem
								button
								selected={props.selected === 1}
								onClick={() => props.handleView(1)}
								className={classes.listItem}
							>
								<ListItemIcon>
									<CardListIcon fill={props.selected === 1 ? '#FFFFFF' : '#BCBBD0'} />
								</ListItemIcon>
							</StyledListItem>
						</Grid>
					</Link>

					<Link to={`${url.replace('viewtile', 'viewtable')}${history.location.search}`}>

						<Grid item style={{ background: '#FFF', borderRadius: '16px' }}>
							<StyledListItem
								button
								selected={props.selected === 0}
								onClick={() => props.handleView(0)}
								className={classes.listItem}
							>
								<ListItemIcon>
									<StrockListIcon fill={props.selected === 0 ? '#FFFFFF' : '#BCBBD0'} />
								</ListItemIcon>
							</StyledListItem>
						</Grid>
					</Link>
				</Grid>
			</List> */}
		</Grid>
	);
}

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);